import PropTypes from 'prop-types';

/**
 * Template for building all React pages.
 * @param {object} props
 * @param {PropTypes.node} props.children - main content of the page
 */
const Page = ({ children }) => {
    return (
        <main>
            {children}
        </main>
    );
};

Page.propTypes = {
    children: PropTypes.node,
};

export default Page;